module.exports = __webpack_public_path__ + "static/media/19-mobile.a56e2315.jpg";